<template>
  <div id="app">
    <Header @pageChange="handlePageChange" :page="page" :helps="helps" :products="products" :solution="solution" />
    <Content @pageChange="handlePageChange" :page="page" />
    <router-view></router-view>
    <Footer :helps="helps" :products="products" :solution="solution" />
    <Board />
  </div>
</template>

<script>
import { getHelpList, getProductList, getSolutionList } from './services'
import Header from './components/Header'
import Content from './components/Content'
import Footer from './components/Footer'
import Board from './components/Board'

export default {
  name: 'App',
  components: {
    Header,
    Content,
    Footer,
    Board
  },

  data: function () {
    return {
      page: this.$router.history.current.name,
      helps: [],
      products: [],
      solution: []
    }
  },

  created () {
    getHelpList().then(res => {
      this.helps = res.data.data.data.children
    })
    getProductList().then(res => {
      this.products = res.data.data.data.children
    })
    getSolutionList().then(res => {
      this.solution = res.data.data.data.children
    })
  },

  methods: {
    handlePageChange (value) {
      this.page = value
    }
  }
}
</script>

<style lang="less">
html {
  min-height: 100%;
}
body {
  margin: 0px;
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
